import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommunityDto, LgaDto, StateDto, ImpactedCommunityDto, IncidentDto} from  "@cradua/data";
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-impactedcommunity',
  templateUrl: './impactedcommunity.component.html',
  styleUrls: ['./impactedcommunity.component.scss']
})
export class ImpactedCommunityComponent implements OnInit {
  @Input() incident:IncidentDto[];

  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() communities:CommunityDto[];
  @Input() selectedIncidentId: IncidentDto;
  @Input() impactedcommunitys: ImpactedCommunityDto[];
  @Output() emitimpactedcommunity = new EventEmitter<ImpactedCommunityDto[]>()
  @Output() deleteEvent = new EventEmitter<any>();
  filterCommunities: CommunityDto[];
  filterLgas: LgaDto[];
  impactedcommunityForm:FormGroup;
  impactcommunityFormArray:FormGroup;
  selectedIndex = null;
  filteredDelete: Array<any> =[];

  selectedImpactedCommunity: any;
  listView = true;
  gridView = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {

    this.createImpactedCommunityForm();
    if(this.selectedIncidentId != null && this.selectedIncidentId.impactedcommunitys?.length){
      this.setImpactedCommunity(this.selectedIncidentId.impactedcommunitys);
    }
  }

  createImpactedCommunityForm(){

    this.impactedcommunityForm = this.fb.group({
      // StateId: [''],
      // LgaId:[''],
      Remarks:[''],
      // CommunityId:[''],
      ImpactedStateId: [''],
      ImpactedLGAId: [''],
      ImpactedCommunityId:[''],
      // id: null,
     IncidentNotificationId: [this.selectedIncidentId.IncidentSerialNo],
      });

      this.impactcommunityFormArray = this.fb.group({ ImpactedCommunitys: this.fb.array([])
        });

  }


  get impactedcommunityFormArray(){
    return this.impactcommunityFormArray.get('ImpactedCommunitys') as FormArray;
   }
  setImpactedCommunity(impactedcommunitys: ImpactedCommunityDto[]) {
    impactedcommunitys.forEach(impactedcomm => {
      this.impactedcommunityFormArray.push(this.fb.group({
        Remarks: impactedcomm.Remarks,
        ImpactedCommunityName:impactedcomm.ImpactedCommunityName,
        ImpactedLGAId:impactedcomm.ImpactedLGAId,
        ImpactedStateId: impactedcomm.ImpactedStateId,
        ImpactedCommunityId: impactedcomm.ImpactedCommunityId,
        id: impactedcomm.id,
        IncidentNotificationId: impactedcomm.IncidentNotificationId,
      }))
    })

  }


  // method to add ImpactedCommunity
  addimpactedcommunity(value: ImpactedCommunityDto) {
    const control  = this.impactcommunityFormArray.controls.ImpactedCommunitys as FormArray;
    control.insert(0,
          this.fb.group({
            Remarks: value.Remarks,
             ImpactedLGAId:value.ImpactedLGAId,
            ImpactedStateId:value.ImpactedStateId,
            ImpactedCommunityId:value.ImpactedCommunityId
          })
       );
  }

  selectImpactedCommunity(value) {}

   // method to delete impactedcommunity from arrary list
  deleteImpactedCommunity(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {

  this.impactedcommunityFormArray.removeAt(index);
  for ( let i = 0; i < this.impactedcommunitys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.impactedcommunitys[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }


  addImpactedCommunity(value: ImpactedCommunityDto) {

    if(this.impactedcommunityForm.invalid) {
      return Swal.fire(
         'Warning!',
         'Please, you cannot add blank field',
         'warning'
       );
       }
       if(this.selectedIndex != null) {

         this.impactedcommunityFormArray.get('ImpactedCommunitys')['controls'][this.selectedIndex]
         .patchValue({
           Remarks: value.Remarks,
           ImpactedLGAId:value.ImpactedLGAId,
           ImpactedStateId:value.ImpactedStateId,
           ImpactedCommunityId:value.ImpactedCommunityId});
       } else {
         this.addimpactedcommunity(value);
       }
       this.selectedIndex = null;
      //  this.impactedcommunityForm.reset()
  }





  onEdit(index, value: ImpactedCommunityDto) {
  console.log("edited value", value);
    this.selectedIndex = index;
    this.impactedcommunityForm.patchValue({
      Remarks: value.Remarks,
      ImpactedLGAId:value.ImpactedLGAId,
      ImpactedStateId:value.ImpactedStateId,
      ImpactedCommunityId:value.ImpactedCommunityId
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.impactedcommunityForm.reset();
  }

  onSubmit() {
     this.emitimpactedcommunity.emit(this.impactcommunityFormArray.value.ImpactedCommunitys);
     if(this.filteredDelete.length > 0) {
      this.deleteEvent.emit(this.filteredDelete);
    }
  }


  protected filterById = <T>(id: string, lookupId: string) =>
  (fieldName: T) => fieldName[lookupId] === id;


onFilterLga(id: string) {
  this.filterLgas = this.lgas.filter(
    this.filterById<LgaDto>(id, "StateId"),
  );
}

onFilterCommunity(id: string) {
 console.log("lgaid", id);
  this.filterCommunities = this.communities.filter(
    this.filterById<CommunityDto>(id, "LgaId"),
  );
}


protected findById = <T>(id: string) =>
(fieldName: T) => fieldName["id"] === id;

getStateName(id: string) {
  return id
    ? this.states.find(this.findById<StateDto>(id))
      .StateName
    : null;
}

getLgaName(id: string) {
  return id
    ? this.lgas.find(this.findById<LgaDto>(id))
      .LgaName
    : null;
}

getCommunityName(id: string) {
  return id
    ? this.communities.find(this.findById<CommunityDto>(id))
      .CommunityName
    : null;
}

onList() {
  this.listView = true;
  this.gridView = false;
}

onGrid() {
  this.gridView = true;
  this.listView = false;
}


}
